"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/icon/style");
var _icon = _interopRequireDefault(require("antd/lib/icon"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
require("antd/lib/auto-complete/style");
var _autoComplete = _interopRequireDefault(require("antd/lib/auto-complete"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _lodash = require("lodash");
var _utils = require("../../utils");
require("./AccountSearch.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var getSearchData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(keyword) {
    var _yield$api$get, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _utils.api.get((0, _utils.getAccountListBySearchKeywordUrl)(keyword));
          case 2:
            _yield$api$get = _context.sent;
            data = _yield$api$get.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getSearchData(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getAccountName = function getAccountName(account) {
  // 2023-01-19 @TarasGumenyuk, BE queries are changed to use .getRawMany(), for performance reasons
  // That's why we have snake case here, don't see a crucial need to convert it here
  var first_name = account.first_name,
    last_name = account.last_name,
    email = account.email;
  return (0, _utils.composeName)([first_name, last_name], ' ') || email;
};
var getGroupTitle = function getGroupTitle(title) {
  return /*#__PURE__*/_react.default.createElement("span", null, title);
};
var Option = _autoComplete.default.Option,
  OptGroup = _autoComplete.default.OptGroup;
var FormItem = _form.default.Item;
var AccountSearch = function AccountSearch(_ref2) {
  var form = _ref2.form,
    onOptionClickProp = _ref2.onOptionClick,
    _ref2$dropdownStyle = _ref2.dropdownStyle,
    dropdownStyle = _ref2$dropdownStyle === void 0 ? {
      width: 300
    } : _ref2$dropdownStyle,
    _ref2$renderName = _ref2.renderName,
    renderName = _ref2$renderName === void 0 ? getAccountName : _ref2$renderName,
    _ref2$renderGroupTitl = _ref2.renderGroupTitle,
    renderGroupTitle = _ref2$renderGroupTitl === void 0 ? getGroupTitle : _ref2$renderGroupTitl;
  var getFieldDecorator = form.getFieldDecorator,
    getFieldError = form.getFieldError;
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    searchData = _useState2[0],
    setSearchData = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchInput = _useState4[0],
    setSearchInput = _useState4[1];
  var history = (0, _reactRouterDom.useHistory)();
  var inputValueRef = (0, _react.useRef)();
  var onAccountClick = function onAccountClick(account) {
    var url = account.role === _utils.UserRoles.Patient ? "/patients/".concat(account.nick_name) : "/clinicians/".concat(account.nick_name);
    history.push(url);
  };
  var onOptionClick = onOptionClickProp || onAccountClick;
  var updateSearchData = (0, _react.useCallback)((0, _lodash.debounce)( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(search) {
      var _inputValueRef$curren, _inputValueRef$curren2;
      var searchValidationError, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              searchValidationError = getFieldError('search');
              if (!(!searchValidationError && search === (inputValueRef === null || inputValueRef === void 0 ? void 0 : (_inputValueRef$curren = inputValueRef.current) === null || _inputValueRef$curren === void 0 ? void 0 : (_inputValueRef$curren2 = _inputValueRef$curren.props) === null || _inputValueRef$curren2 === void 0 ? void 0 : _inputValueRef$curren2.value) && search.length >= _utils.MIN_STRING_TO_SEARCH_LENGTH)) {
                _context2.next = 8;
                break;
              }
              _context2.next = 4;
              return getSearchData(search);
            case 4:
              data = _context2.sent;
              setSearchData(data);
              _context2.next = 9;
              break;
            case 8:
              clearSearchData();
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), 700), []);
  (0, _react.useEffect)(function () {
    updateSearchData(searchInput);
    if (searchInput.length < _utils.MIN_STRING_TO_SEARCH_LENGTH) {
      clearSearchData();
    }
  }, [searchInput]);
  var clearSearchData = function clearSearchData() {
    if (searchInput.length < _utils.MIN_STRING_TO_SEARCH_LENGTH) {
      setSearchData({});
    }
  };
  var options = (0, _react.useMemo)(function () {
    return Object.keys(searchData).map(function (group) {
      return /*#__PURE__*/_react.default.createElement(OptGroup, {
        key: group,
        label: renderGroupTitle(group)
      }, searchData[group].map(function (opt) {
        var email = opt.email,
          id = opt.id;
        return /*#__PURE__*/_react.default.createElement(Option, {
          key: id,
          value: email,
          onClick: function onClick() {
            return onOptionClick(opt);
          }
        }, renderName(opt));
      }));
    });
  }, [searchData]);
  return /*#__PURE__*/_react.default.createElement(_form.default, null, /*#__PURE__*/_react.default.createElement(FormItem, {
    name: "search"
  }, getFieldDecorator('search', {
    initialValue: searchInput,
    rules: [{
      validateFirst: true
    }, _utils.whitespaceValidator]
  })( /*#__PURE__*/_react.default.createElement("div", {
    className: "certain-category-search-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_autoComplete.default, {
    className: "certain-category-search",
    dropdownClassName: "certain-category-search-dropdown",
    dropdownMatchSelectWidth: true,
    dropdownStyle: dropdownStyle,
    size: "large",
    dataSource: options,
    placeholder: "Search",
    optionLabelProp: "value",
    ref: inputValueRef,
    onChange: function onChange(v) {
      return setSearchInput(v || '');
    },
    value: searchInput
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    suffix: /*#__PURE__*/_react.default.createElement(_icon.default, {
      type: "search",
      className: "certain-category-icon"
    })
  }))))));
};
var _default = _form.default.create({
  name: 'search'
})(AccountSearch);
exports.default = _default;